import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import clubStore from "../../../storage/ClubStore";
import TeamList from "../TeamList";

const Teams = () => {
    useEffect(() => {
        clubStore.getTeams();
    }, []);
    return (
        <TeamList role={"MGR"}/>
    );
}

export default observer(Teams);